/* eslint-disable react/no-array-index-key */
import * as MUI from "@mui/material";
import * as Icon from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useState } from "react";

type Items = {
  label: string;
  to: string;
  icon?: React.ReactElement;
  isSelected?: boolean;
};

type MenuProps = {
  titulo: string;
  menu: Items[];
};

export const Menu: React.FC<MenuProps> = ({ menu, titulo }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawerOpen = (): void => setDrawerOpen(!drawerOpen);

  const theme = MUI.useTheme();
  const mdDown = MUI.useMediaQuery(theme.breakpoints.down("md"));
  return (
    <>
      {mdDown ? (
        <MUI.Box>
          <MUI.IconButton onClick={toggleDrawerOpen}>
            <Icon.Menu />
          </MUI.IconButton>
          <MUI.Drawer
            anchor="left"
            open={drawerOpen}
            onClose={toggleDrawerOpen}
          >
            <MUI.Box
              display="flex"
              flexDirection="column"
              height="100%"
              width={theme.spacing(28)}
              bgcolor={theme.palette.primary.light}
              sx={{
                displayPrint: "none",
              }}
            >
              <MUI.List>
                <MUI.Typography
                  sx={{ color: "#fff !important" }}
                  variant="h6"
                  textAlign="center"
                >
                  {titulo}
                </MUI.Typography>
                {menu.map((lista, index) => (
                  <MUI.ListItemButton
                    key={index}
                    component={Link}
                    to={lista.to}
                    selected={lista.isSelected}
                    sx={{
                      "&.Mui-selected": {
                        backgroundColor: `${theme.palette.primary.main}`,
                        "&.Mui-focusVisible": {
                          backgroundColor: `${theme.palette.primary.dark}`,
                        },
                        ":hover": {
                          backgroundColor: `${theme.palette.primary.dark}`,
                        },
                      },
                    }}
                  >
                    <MUI.ListItemIcon>{lista.icon}</MUI.ListItemIcon>
                    <MUI.ListItemText
                      sx={{ color: "white" }}
                      primary={lista.label}
                    />
                  </MUI.ListItemButton>
                ))}
              </MUI.List>
            </MUI.Box>
          </MUI.Drawer>
        </MUI.Box>
      ) : (
        <MUI.Box
          display="flex"
          flexDirection="column"
          height="100%"
          width={theme.spacing(30)}
          bgcolor={theme.palette.primary.light}
          sx={{
            displayPrint: "none",
          }}
        >
          <MUI.List>
            <MUI.Typography
              sx={{ color: "#fff !important" }}
              variant="h6"
              textAlign="center"
            >
              {titulo}
            </MUI.Typography>
            {menu.map((lista, index) => (
              <MUI.ListItemButton
                key={index}
                component={Link}
                to={lista.to}
                selected={lista.isSelected}
                sx={{
                  "&.Mui-selected": {
                    backgroundColor: `${theme.palette.primary.main}`,
                    "&.Mui-focusVisible": {
                      backgroundColor: `${theme.palette.primary.dark}`,
                    },
                    ":hover": {
                      backgroundColor: `${theme.palette.primary.dark}`,
                    },
                  },
                }}
              >
                <MUI.ListItemIcon>{lista.icon}</MUI.ListItemIcon>
                <MUI.ListItemText
                  sx={{ color: "white" }}
                  primary={lista.label}
                />
              </MUI.ListItemButton>
            ))}
          </MUI.List>
        </MUI.Box>
      )}
    </>
  );
};
